export const getBoundingClientRectFrom = (el, root = document.body.querySelector(".oj-App")) => {
    const rrect = root?.getBoundingClientRect();
    const rect = el.getBoundingClientRect();
    return {
        x: rect.x - rrect.x,
        y: rect.y - rrect.y,
        width: rect.width,
        height: rect.height
    };
};
let header;
export const getHeaderHeight = () => {
    header ??= document.body.querySelector("header.header");
    return header?.clientHeight ?? 0;
};
